// src/screens/yonetim/UrunYonetimScreen.js
import React, { useState, useEffect, useCallback } from 'react';
import {
  View, Text, StyleSheet, TextInput, FlatList, TouchableOpacity,
  ActivityIndicator, ScrollView, Alert
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { SafeAreaView } from 'react-native-safe-area-context';
import { useNavigation, useFocusEffect } from '@react-navigation/native';
import CustomAlert from '../../components/CustomAlert';
import BarkodTarayici from '../../components/BarkodTarayici';
import CariSecimModal from '../../components/CariSecimModal'; // ← YENİ
import CONFIG from '../../config/Config';


function turkceNormalize(metin) {
  if (!metin) return '';
  return metin
    .replace(/ç/g, 'c').replace(/Ç/g, 'c')
    .replace(/ğ/g, 'g').replace(/Ğ/g, 'g')
    .replace(/ı/g, 'i').replace(/İ/g, 'i')
    .replace(/ö/g, 'o').replace(/Ö/g, 'o')
    .replace(/ş/g, 's').replace(/Ş/g, 's')
    .replace(/ü/g, 'u').replace(/Ü/g, 'u')
    .toLowerCase()
    .trim();
}

// ── Dropdown Bileşeni ────────────────────────────────────────
function Dropdown({ label, value, options, onSelect }) {
  const [open, setOpen] = useState(false);
  return (
    <View style={dd.wrapper}>
      <Text style={dd.label}>{label}</Text>
      <TouchableOpacity style={dd.btn} onPress={() => setOpen(!open)}>
        <Text style={[dd.btnText, !value && { color: '#bdc3c7' }]}>
          {value || `${label} seç...`}
        </Text>
        <Ionicons name={open ? 'chevron-up' : 'chevron-down'} size={16} color="#7f8c8d" />
      </TouchableOpacity>
      {open && (
        <View style={dd.list}>
          {options.map(opt => (
            <TouchableOpacity
              key={opt}
              style={[dd.item, value === opt && dd.itemSelected]}
              onPress={() => { onSelect(opt); setOpen(false); }}
            >
              <Text style={[dd.itemText, value === opt && dd.itemTextSelected]}>{opt}</Text>
              {value === opt && <Ionicons name="checkmark" size={16} color="#2196F3" />}
            </TouchableOpacity>
          ))}
        </View>
      )}
    </View>
  );
}

// ── Form Input Bileşeni ──────────────────────────────────────
function FormInput({ label, icon, value, onChangeText, placeholder, keyboardType, rightIcon, onRightIconPress }) {
  return (
    <View style={styles.formGroup}>
      <Text style={styles.formLabel}>
        <Ionicons name={icon} size={13} color="#7f8c8d" />{"  "}{label}
      </Text>
      <View style={styles.formInputRow}>
        <TextInput
          style={[styles.formInput, rightIcon && styles.formInputWithIcon]}
          value={value}
          onChangeText={onChangeText}
          placeholder={placeholder || label}
          placeholderTextColor="#bdc3c7"
          keyboardType={keyboardType || 'default'}
        />
        {rightIcon && (
          <TouchableOpacity style={styles.inputIconBtn} onPress={onRightIconPress}>
            <Ionicons name={rightIcon} size={20} color="#FF9800" />
          </TouchableOpacity>
        )}
      </View>
    </View>
  );
}

// ── Cariye Özel Satır Bileşeni ───────────────────────────────
function CariOzelSatir({ cari, onCariSec, onKaldir }) {
  const cariAdi = cari && typeof cari === 'object' && Object.keys(cari).length > 0
    ? (cari.Isim || cari.CariAdi || cari.Ad || `Cari #${cari.CariID || cari.id}`)
    : null;

  return (
    <View style={styles.formGroup}>
      <Text style={styles.formLabel}>
        <Ionicons name="person-outline" size={13} color="#7f8c8d" />{"  "}Cariye Özel
      </Text>

      {cariAdi ? (
        <View style={styles.cariSeciliKutu}>
          <View style={styles.cariSecIc}>
            <Ionicons name="person" size={16} color="#FF9800" />
            <View>
              <Text style={styles.cariSecAdi} numberOfLines={1}>{cariAdi}</Text>
              <Text style={styles.cariOzelAciklama}>Bu ürün yalnızca bu cariye satılabilir</Text>
            </View>
          </View>
          <TouchableOpacity style={styles.cariKaldirBtn} onPress={onKaldir}>
            <Ionicons name="close" size={16} color="#E53935" />
          </TouchableOpacity>
        </View>
      ) : (
        <TouchableOpacity style={styles.cariSecBtn} onPress={onCariSec}>
          <View style={styles.cariSecIc}>
            <Ionicons name="person-add-outline" size={16} color="#95a5a6" />
            <Text style={styles.cariSecPlaceholder}>Cari seç...</Text>
          </View>
          <Ionicons name="chevron-forward" size={16} color="#bdc3c7" />
        </TouchableOpacity>
      )}
    </View>
  );
}

// ── Ana Ekran ────────────────────────────────────────────────
export default function UrunYonetimScreen() {
  const navigation = useNavigation();

  const [urunler, setUrunler]               = useState([]);
  const [cariler, setCariler]               = useState([]);   // cari lookup için
  const [isLoading, setIsLoading]           = useState(false);
  const [searchText, setSearchText]         = useState('');
  const [aktifKategori, setAktifKategori]   = useState('Tümü');
  const [kategoriler, setKategoriler]       = useState([]);
  const [birimler, setBirimler]             = useState([]);

  // Form state
  const [seciliUrun, setSeciliUrun]         = useState(null);
  const [isYeni, setIsYeni]                 = useState(false);
  const [isSaving, setIsSaving]             = useState(false);

  const [formId, setFormId]                 = useState('');
  const [formAdi, setFormAdi]               = useState('');
  const [formKodu, setFormKodu]             = useState('');
  const [formPLU, setFormPLU]               = useState('');
  const [formFiyat, setFormFiyat]           = useState('');
  const [formBirim, setFormBirim]           = useState('');
  const [formKategori, setFormKategori]     = useState('');

  // Cariye Özel state ← YENİ
  const [cariOzelCari, setCariOzelCari]     = useState(null);   // seçili cari objesi

  // Modal state
  const [barkodAcik, setBarkodAcik]         = useState(false);
  const [cariModalAcik, setCariModalAcik]   = useState(false);  // ← YENİ

  // Alert state
  const [showSuccess, setShowSuccess]       = useState(false);
  const [successMsg, setSuccessMsg]         = useState('');
  const [showError, setShowError]           = useState(false);
  const [errorMsg, setErrorMsg]             = useState('');
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [silinecekId, setSilinecekId]       = useState(null);

  useFocusEffect(useCallback(() => { fetchUrunler(); }, []));

  useEffect(() => {
    navigation.setOptions({
      headerLeft: seciliUrun
        ? () => (
            <TouchableOpacity onPress={() => setSeciliUrun(null)} style={{ marginLeft: 4 }}>
              <Ionicons name="arrow-back" size={24} color="#2c3e50" />
            </TouchableOpacity>
          )
        : undefined,
      title: !seciliUrun ? 'Ürün Yönetimi' : isYeni ? 'Yeni Ürün' : 'Ürün Düzenle',
    });
  }, [seciliUrun, isYeni]);

  const fetchUrunler = async () => {
    setIsLoading(true);
    try {
      const urunRes = await fetch(`${CONFIG.API_BASE_URL}/urunler`, { headers: { 'X-App-Env': CONFIG.ENV } });
      const urunResult = await urunRes.json();
      if (urunResult.success) {
        setUrunler(urunResult.data);
        const katSet   = [...new Set(urunResult.data.map(u => u.Cat).filter(Boolean))];
        const birimSet = [...new Set(urunResult.data.map(u => u.Birim).filter(Boolean))];
        setKategoriler(katSet);
        setBirimler(birimSet);
      } else {
        Alert.alert("Uyarı", urunResult.message);
      }
    } catch {
      Alert.alert("Hata", "Ürünler çekilemedi.");
    } finally {
      setIsLoading(false);
    }
    // Cariler ayrı — hata ürün listesini etkilemesin
    try {
      const cariRes = await fetch(`${CONFIG.API_BASE_URL}/cari`, { headers: { 'X-App-Env': CONFIG.ENV } });
      const cariResult = await cariRes.json();
      if (cariResult.data) setCariler(cariResult.data);
    } catch {
      // sessizce geç, cariler modal açılınca tekrar denenebilir
    }
  };

  const aramaQuery = turkceNormalize(searchText);
  const filtrelenmis = urunler.filter(u => {
    const katFiltre = aktifKategori === 'Tümü' || u.Cat === aktifKategori;
    const aramaFiltre = !searchText ||
      turkceNormalize(u.UrunAdi).includes(aramaQuery) ||
      u.UrunKodu?.toString() === searchText.trim() ||
      u.UrunKodu?.toString().startsWith(searchText.trim()) ||
      u.PLU?.toString() === searchText.trim();
    return katFiltre && aramaFiltre;
  });

  const formTemizle = () => {
    setFormId(''); setFormAdi(''); setFormKodu('');
    setFormPLU(''); setFormFiyat(''); setFormBirim(''); setFormKategori('');
    setCariOzelCari(null);
  };

  const urunSec = (urun) => {
    setIsYeni(false);
    setFormId(urun.id?.toString() || '');
    setFormAdi(urun.UrunAdi || '');
    setFormKodu(urun.UrunKodu?.toString() || '');
    setFormPLU(urun.PLU?.toString() || '');
    setFormFiyat(urun.Fiyat?.toString() || '');
    setFormBirim(urun.Birim || '');
    setFormKategori(urun.Cat || '');

    let bulunanCari = null;
    if (urun.OzelCari) {
      bulunanCari = cariler.find(c => String(c.CariID || c.id) === String(urun.OzelCari));
      
      // TERMİNALDEN BURAYA BAKIN: Bulunan cari objesinin içi nasıl görünüyor?
      //console.log("Eşleşen Cari Objesi:", bulunanCari);
      console.log(urun);

      if (!bulunanCari) {
        bulunanCari = { 
          CariID: urun.OzelCari, 
          CariAdi: urun.CariAdi || `Cari #${urun.OzelCari}`
        };
      }
    }
    setCariOzelCari(bulunanCari);




    
    
    setSeciliUrun(urun);
  };

  const yeniUrunAc = () => {
    setIsYeni(true);
    formTemizle();
    setSeciliUrun({});
  };

  const barkodOkundu = (deger) => {
    setFormKodu(deger);
  };

  const urunKaydet = async () => {
    if (!formAdi.trim())  { setErrorMsg("Ürün adı zorunludur!");  setShowError(true); return; }
    if (!formFiyat)       { setErrorMsg("Fiyat zorunludur!");      setShowError(true); return; }
    if (!formKodu.trim()) { setErrorMsg("Ürün kodu zorunludur!"); setShowError(true); return; }

    setIsSaving(true);
    try {
      const payload = {
        UrunAdi:       formAdi.trim(),
        UrunKodu:      parseInt(formKodu) || 0,
        PLU:           formPLU ? parseInt(formPLU) : null,
        Fiyat:         parseFloat(formFiyat) || 0,
        Birim:         formBirim || null,
        Cat:           formKategori || null,
        // Cariye özel alanlar ← YENİ
        OzelCari:      cariOzelCari ? (cariOzelCari.CariID || null) : null,
      };
      const url    = isYeni ? `${CONFIG.API_BASE_URL}/urunler` : `${CONFIG.API_BASE_URL}/urunler/${formId}`;
      const method = isYeni ? 'POST' : 'PUT';

      const response = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json', 'X-App-Env': CONFIG.ENV },
        body: JSON.stringify(payload),
      });
      const result = await response.json();

      if (result.success) {
        setSuccessMsg(isYeni ? "Ürün başarıyla eklendi." : "Ürün güncellendi.");
        setShowSuccess(true);
        setSeciliUrun(null);
        fetchUrunler();
      } else {
        setErrorMsg(result.message || "İşlem başarısız.");
        setShowError(true);
      }
    } catch {
      setErrorMsg("Sunucuya bağlanılamadı.");
      setShowError(true);
    } finally {
      setIsSaving(false);
    }
  };

  const urunSilOnay = (id) => {
    setSilinecekId(id);
    setShowDeleteConfirm(true);
  };

  const urunSil = async () => {
    setShowDeleteConfirm(false);
    try {
      const response = await fetch(`${CONFIG.API_BASE_URL}/urunler/${silinecekId}`, { method: 'DELETE', headers: { 'X-App-Env': CONFIG.ENV } });
      const result = await response.json();
      if (result.success) {
        setSuccessMsg("Ürün silindi.");
        setShowSuccess(true);
        setSeciliUrun(null);
        fetchUrunler();
      } else {
        setErrorMsg(result.message || "Silinemedi.");
        setShowError(true);
      }
    } catch {
      setErrorMsg("Sunucuya bağlanılamadı.");
      setShowError(true);
    }
  };

  const formatTL = (val) => {
    if (val === null || val === undefined) return "—";
    return parseFloat(val).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " ₺";
  };

  // ── FORM GÖRÜNÜMÜ ────────────────────────────────────────────
  if (seciliUrun !== null) {
    return (
      <SafeAreaView style={styles.safeArea} edges={['left', 'right', 'bottom']}>
        <ScrollView contentContainerStyle={styles.formContainer} keyboardShouldPersistTaps="handled">

          {!isYeni && (
            <View style={styles.idKutu}>
              <Ionicons name="barcode-outline" size={14} color="#2196F3" />
              <Text style={styles.idText}>Ürün ID: <Text style={{ fontWeight: 'bold' }}>{formId}</Text></Text>
            </View>
          )}

          <FormInput
            label="Ürün Adı *"
            icon="fast-food-outline"
            value={formAdi}
            onChangeText={setFormAdi}
            placeholder="Kuzu But, Dana Kıyma..."
          />

          <FormInput
            label="Ürün Kodu *"
            icon="barcode-outline"
            value={formKodu}
            onChangeText={setFormKodu}
            placeholder="Barkod numarası"
            keyboardType="numeric"
            rightIcon="scan-outline"
            onRightIconPress={() => setBarkodAcik(true)}
          />

          <FormInput
            label="PLU (Terazi)"
            icon="scale-outline"
            value={formPLU}
            onChangeText={setFormPLU}
            placeholder="Kısa terazi kodu"
            keyboardType="numeric"
          />
          <FormInput
            label="Fiyat (₺) *"
            icon="pricetag-outline"
            value={formFiyat}
            onChangeText={setFormFiyat}
            placeholder="0.00"
            keyboardType="decimal-pad"
          />

          <Dropdown
            label="Birim"
            value={formBirim}
            options={birimler.length > 0 ? birimler : ['KG', 'Adet']}
            onSelect={setFormBirim}
          />

          <Dropdown
            label="Kategori"
            value={formKategori}
            options={kategoriler.length > 0 ? kategoriler : ['Et', 'Şarküteri', 'Balık', 'Meze', 'Diğer']}
            onSelect={setFormKategori}
          />

          {/* ── Cariye Özel Fiyat ─────────────────── YENİ */}
          <View style={styles.bolucuCizgi} />
          <CariOzelSatir
            cari={cariOzelCari}
            onCariSec={() => setCariModalAcik(true)}
            onKaldir={() => setCariOzelCari(null)}
          />

          <TouchableOpacity
            style={[styles.kaydetBtn, isSaving && { opacity: 0.6 }]}
            onPress={urunKaydet}
            disabled={isSaving}
          >
            {isSaving
              ? <ActivityIndicator color="#fff" />
              : <>
                  <Ionicons name={isYeni ? "add-circle-outline" : "save-outline"} size={20} color="#fff" />
                  <Text style={styles.kaydetBtnText}>{isYeni ? 'Ürün Ekle' : 'Değişiklikleri Kaydet'}</Text>
                </>
            }
          </TouchableOpacity>

          {!isYeni && (
            <TouchableOpacity style={styles.silBtn} onPress={() => urunSilOnay(formId)}>
              <Ionicons name="trash-outline" size={20} color="#fff" />
              <Text style={styles.silBtnText}>Ürünü Sil</Text>
            </TouchableOpacity>
          )}

          <View style={{ height: 40 }} />
        </ScrollView>

        {/* Barkod Tarayıcı */}
        <BarkodTarayici
          visible={barkodAcik}
          onClose={() => setBarkodAcik(false)}
          onBarkodOkundu={barkodOkundu}
        />

        {/* Cari Seçim Modalı ← YENİ */}
        <CariSecimModal
          visible={cariModalAcik}
          onClose={() => setCariModalAcik(false)}
          onSelect={(cari) => {
            setCariOzelCari(cari);
          }}
          secilenCari={cariOzelCari}
        />

        {showError && (
          <CustomAlert visible={showError} title="Uyarı" message={errorMsg} type="error" confirmText="Tamam" onConfirm={() => setShowError(false)} />
        )}
        {showDeleteConfirm && (
          <CustomAlert
            visible={showDeleteConfirm}
            title="Ürünü Sil"
            message={`"${formAdi}" ürününü silmek istediğinizden emin misiniz?`}
            type="warning"
            confirmText="Evet, Sil"
            cancelText="İptal"
            showCancel
            onConfirm={urunSil}
            onCancel={() => setShowDeleteConfirm(false)}
          />
        )}
        {showSuccess && (
          <CustomAlert visible={showSuccess} title="Başarılı" message={successMsg} type="success" confirmText="Tamam" onConfirm={() => setShowSuccess(false)} />
        )}
      </SafeAreaView>
    );
  }

  // ── LİSTE GÖRÜNÜMÜ ───────────────────────────────────────────
  return (
    <SafeAreaView style={styles.safeArea} edges={['left', 'right', 'bottom']}>

      <View style={styles.searchRow}>
        <View style={styles.searchBox}>
          <Ionicons name="search-outline" size={18} color="#95a5a6" style={{ marginRight: 8 }} />
          <TextInput
            style={styles.searchInput}
            placeholder="Ürün adı, barkod veya PLU..."
            placeholderTextColor="#95a5a6"
            value={searchText}
            onChangeText={setSearchText}
          />
          {searchText.length > 0 && (
            <TouchableOpacity onPress={() => setSearchText('')}>
              <Ionicons name="close-circle" size={18} color="#95a5a6" />
            </TouchableOpacity>
          )}
        </View>
        <TouchableOpacity style={styles.yeniBtn} onPress={yeniUrunAc}>
          <Ionicons name="add" size={24} color="#fff" />
        </TouchableOpacity>
      </View>

      <ScrollView
        horizontal
        showsHorizontalScrollIndicator={false}
        style={styles.katFiltreWrapper}
        contentContainerStyle={styles.katFiltre}
      >
        {['Tümü', ...kategoriler].map(kat => (
          <TouchableOpacity
            key={kat}
            style={[styles.katBtn, aktifKategori === kat && styles.katBtnActive]}
            onPress={() => setAktifKategori(kat)}
          >
            <Text style={[styles.katBtnText, aktifKategori === kat && styles.katBtnTextActive]}>
              {kat}
            </Text>
          </TouchableOpacity>
        ))}
      </ScrollView>

      <Text style={styles.sayac}>{filtrelenmis.length} ürün</Text>

      {isLoading ? (
        <View style={styles.loadingBox}>
          <ActivityIndicator size="large" color="#FF9800" />
          <Text style={styles.loadingText}>Ürünler yükleniyor...</Text>
        </View>
      ) : (
        <FlatList
          keyboardShouldPersistTaps="handled"
          data={filtrelenmis}
          keyExtractor={item => item.id.toString()}
          contentContainerStyle={{ paddingHorizontal: 16, paddingBottom: 40 }}
          renderItem={({ item }) => (
            <TouchableOpacity style={styles.urunItem} onPress={() => urunSec(item)}>
              <View style={[styles.katBar, { backgroundColor: katRenk(item.Cat) }]} />
              <View style={{ flex: 1, paddingLeft: 12 }}>
                <Text style={styles.urunAdi} numberOfLines={1}>{item.UrunAdi}</Text>
                <View style={styles.urunAltRow}>
                  {item.UrunKodu ? <Text style={styles.urunAltText}>#{item.UrunKodu}</Text> : null}
                  {item.PLU     ? <Text style={styles.urunAltText}>PLU: {item.PLU}</Text>  : null}
                  {item.Birim   ? <View style={styles.birimBadge}><Text style={styles.birimText}>{item.Birim}</Text></View> : null}
                  {item.Cat     ? <View style={[styles.katBadge, { backgroundColor: katRenk(item.Cat) + '22' }]}>
                                    <Text style={[styles.katBadgeText, { color: katRenk(item.Cat) }]}>{item.Cat}</Text>
                                  </View> : null}
                  {/* Cariye özel ürünse rozet göster ← YENİ */}
                  {item.OzelCari ? (
                    <View style={styles.cariBadge}>
                      <Ionicons name="person" size={9} color="#FF9800" />
                      <Text style={styles.cariBadgeText}>Özel</Text>
                    </View>
                  ) : null}
                </View>
              </View>
              {item.Fiyat > 0 && <Text style={styles.urunFiyat}>{formatTL(item.Fiyat)}</Text>}
              <Ionicons name="chevron-forward" size={18} color="#bdc3c7" style={{ marginLeft: 6 }} />
            </TouchableOpacity>
          )}
          ListEmptyComponent={
            <View style={{ alignItems: 'center', paddingTop: 60 }}>
              <Ionicons name="fast-food-outline" size={56} color="#bdc3c7" />
              <Text style={styles.emptyText}>Ürün bulunamadı.</Text>
            </View>
          }
        />
      )}

      {showSuccess && (
        <CustomAlert visible={showSuccess} title="Başarılı" message={successMsg} type="success" confirmText="Tamam" onConfirm={() => setShowSuccess(false)} />
      )}
    </SafeAreaView>
  );
}

function katRenk(kat) {
  const renkler = {
    'Et':         '#E53935',
    'Şarküteri':  '#FB8C00',
    'Balık':      '#1E88E5',
    'Meze':       '#43A047',
    'Diğer':      '#8E24AA',
  };
  return renkler[kat] || '#90A4AE';
}

const dd = StyleSheet.create({
  wrapper:          { marginBottom: 16 },
  label:            { fontSize: 13, color: '#7f8c8d', fontWeight: '600', marginBottom: 6 },
  btn:              { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#fff', borderWidth: 1, borderColor: '#e9ecef', borderRadius: 10, padding: 12 },
  btnText:          { fontSize: 15, color: '#2c3e50' },
  list:             { backgroundColor: '#fff', borderWidth: 1, borderColor: '#e9ecef', borderRadius: 10, marginTop: 4, overflow: 'hidden' },
  item:             { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', padding: 12, borderBottomWidth: 1, borderBottomColor: '#f5f5f5' },
  itemSelected:     { backgroundColor: '#E3F2FD' },
  itemText:         { fontSize: 15, color: '#2c3e50' },
  itemTextSelected: { color: '#2196F3', fontWeight: '600' },
});

const styles = StyleSheet.create({
  safeArea:           { flex: 1, backgroundColor: '#F5F7FA' },
  searchRow:          { flexDirection: 'row', alignItems: 'center', margin: 16, gap: 10 },
  searchBox:          { flex: 1, flexDirection: 'row', alignItems: 'center', backgroundColor: '#fff', borderRadius: 12, paddingHorizontal: 12, paddingVertical: 10, borderWidth: 1, borderColor: '#e9ecef' },
  searchInput:        { flex: 1, fontSize: 15, color: '#2c3e50' },
  yeniBtn:            { backgroundColor: '#FF9800', width: 46, height: 46, borderRadius: 12, justifyContent: 'center', alignItems: 'center' },
  katFiltreWrapper:   { height: 50, flexGrow: 0, flexShrink: 0 },
  katFiltre:          { paddingHorizontal: 16, alignItems: 'center', gap: 8 },
  katBtn:             { paddingHorizontal: 14, paddingVertical: 8, backgroundColor: '#E0E6ED', borderRadius: 20, height: 36, justifyContent: 'center' },
  katBtnActive:       { backgroundColor: '#2C3E50' },
  katBtnText:         { fontSize: 13, color: '#7F8C8D', fontWeight: '600' },
  katBtnTextActive:   { color: '#fff' },
  sayac:              { fontSize: 12, color: '#95a5a6', marginLeft: 16, marginBottom: 6 },
  loadingBox:         { flex: 1, justifyContent: 'center', alignItems: 'center' },
  loadingText:        { marginTop: 10, color: '#7f8c8d', fontSize: 15 },
  urunItem:           { flexDirection: 'row', alignItems: 'center', backgroundColor: '#fff', borderRadius: 12, marginBottom: 10, overflow: 'hidden', elevation: 1, paddingRight: 12, paddingVertical: 12 },
  katBar:             { width: 5, alignSelf: 'stretch', minHeight: 56 },
  urunAdi:            { fontSize: 15, fontWeight: '600', color: '#2c3e50', marginBottom: 4 },
  urunAltRow:         { flexDirection: 'row', alignItems: 'center', gap: 6, flexWrap: 'wrap' },
  urunAltText:        { fontSize: 12, color: '#95a5a6' },
  birimBadge:         { backgroundColor: '#E3F2FD', paddingHorizontal: 6, paddingVertical: 2, borderRadius: 4 },
  birimText:          { fontSize: 10, fontWeight: 'bold', color: '#1E88E5' },
  katBadge:           { paddingHorizontal: 6, paddingVertical: 2, borderRadius: 4 },
  katBadgeText:       { fontSize: 10, fontWeight: 'bold' },
  urunFiyat:          { fontSize: 15, fontWeight: '800', color: '#2c3e50', marginRight: 4 },
  emptyText:          { textAlign: 'center', color: '#95a5a6', marginTop: 12, fontSize: 15 },
  // Cariye özel rozet (liste) ← YENİ
  cariBadge:          { flexDirection: 'row', alignItems: 'center', gap: 3, backgroundColor: '#FFF3E0', paddingHorizontal: 5, paddingVertical: 2, borderRadius: 4 },
  cariBadgeText:      { fontSize: 10, fontWeight: 'bold', color: '#FF9800' },
  // Form
  formContainer:      { padding: 16 },
  idKutu:             { flexDirection: 'row', alignItems: 'center', backgroundColor: '#E3F2FD', borderRadius: 8, paddingHorizontal: 12, paddingVertical: 8, marginBottom: 16, gap: 6 },
  idText:             { fontSize: 13, color: '#1565C0' },
  formGroup:          { marginBottom: 16 },
  formLabel:          { fontSize: 13, color: '#7f8c8d', fontWeight: '600', marginBottom: 6 },
  formInputRow:       { flexDirection: 'row', alignItems: 'center' },
  formInput:          { flex: 1, backgroundColor: '#fff', borderWidth: 1, borderColor: '#e9ecef', borderRadius: 10, padding: 12, fontSize: 15, color: '#2c3e50' },
  formInputWithIcon:  { borderTopRightRadius: 0, borderBottomRightRadius: 0, borderRightWidth: 0 },
  inputIconBtn:       { backgroundColor: '#fff', borderWidth: 1, borderColor: '#e9ecef', borderLeftWidth: 0, borderTopRightRadius: 10, borderBottomRightRadius: 10, paddingHorizontal: 12, paddingVertical: 12, justifyContent: 'center', alignItems: 'center' },
  inputIconBtnRed:    { borderColor: '#FFCDD2' },
  kaydetBtn:          { backgroundColor: '#FF9800', borderRadius: 12, paddingVertical: 15, flexDirection: 'row', justifyContent: 'center', alignItems: 'center', gap: 8, marginBottom: 12 },
  kaydetBtnText:      { fontSize: 16, fontWeight: 'bold', color: '#fff' },
  silBtn:             { backgroundColor: '#E53935', borderRadius: 12, paddingVertical: 15, flexDirection: 'row', justifyContent: 'center', alignItems: 'center', gap: 8 },
  silBtnText:         { fontSize: 16, fontWeight: 'bold', color: '#fff' },
  // Cariye özel form alanı
  bolucuCizgi:        { height: 1, backgroundColor: '#e9ecef', marginBottom: 16 },
  cariSecBtn:         { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#fff', borderWidth: 1, borderColor: '#e9ecef', borderRadius: 10, padding: 12 },
  cariSeciliKutu:     { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#FFF8F0', borderWidth: 1, borderColor: '#FF9800', borderRadius: 10, padding: 12 },
  cariSecIc:          { flexDirection: 'row', alignItems: 'center', gap: 10, flex: 1 },
  cariSecAdi:         { fontSize: 14, color: '#E65100', fontWeight: '700' },
  cariSecPlaceholder: { fontSize: 15, color: '#bdc3c7' },
  cariOzelAciklama:   { fontSize: 11, color: '#95a5a6', marginTop: 2 },
  cariKaldirBtn:      { width: 28, height: 28, borderRadius: 8, backgroundColor: '#FFEBEE', justifyContent: 'center', alignItems: 'center' },
});